import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CountrySite, SelectedTeam, Team, TeamsManagementState } from './types'

export const initialState: TeamsManagementState = {
  isLoadingTeams: false,
  teams: [],
  countrySites: [],
  selectedTeam: {
    id: 0,
    name: '',
    site_id: '',
  },
  teamsError: '',
}

export const TeamsManagementSlice = createSlice({
  name: 'teamsManagement',
  initialState,
  reducers: {
    updateTeamsManagementIsLoadingTeams: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTeams = action.payload
    },
    updateTeamsManagementTeams: (state, action: PayloadAction<Team[]>) => {
      state.teams = action.payload
    },
    updateTeamsManagementCountrySites: (state, action: PayloadAction<CountrySite[]>) => {
      state.countrySites = action.payload
    },
    updateTeamsManagementSelectedTeam: (state, action: PayloadAction<SelectedTeam>) => {
      state.selectedTeam = action.payload
    },
    updateTeamsManagementTeamsError: (
      state,
      action: PayloadAction<Record<string, unknown> | { error?: string } | string>,
    ) => {
      state.teamsError = action.payload
    },
    clearTeamsManagement: () => initialState,
  },
})

export const {
  updateTeamsManagementIsLoadingTeams,
  updateTeamsManagementTeams,
  updateTeamsManagementCountrySites,
  updateTeamsManagementSelectedTeam,
  updateTeamsManagementTeamsError,
  clearTeamsManagement,
} = TeamsManagementSlice.actions

export default TeamsManagementSlice.reducer
